module.exports = __webpack_public_path__ + "img/logo@2x.0a03feb0.png";